import React from "react";
import Form, { useForm } from "rc-field-form";
import style from "../../index.module.scss";
import { Button, Col, Icon, Input, Row } from "antd";
import FieldWithError from "components/FieldWithError";
import { useAtomValue } from "jotai";
import { loginModeAtom, loginUnifySetAtom } from "Stores/SettingsStore";
import { isTrue } from "Utils/filter";
import useRequestFn from "Utils/useRequestFn";

export interface FormFields {
    username: string;
    password: string;
    code: string;
}

export interface AccountModeProps {
    captcha?: string;
    refreshCaptcha?(username: string): void;
    onSubmit(data: FormFields): Promise<void>;
}

export default function AccountMode({
    captcha,
    refreshCaptcha,
    onSubmit
}: AccountModeProps) {
    const [form] = useForm<FormFields>();

    const loginMode = useAtomValue(loginModeAtom);
    const loginUnifySet = useAtomValue(loginUnifySetAtom);

    const [onFinish, { loading }] = useRequestFn(onSubmit);

    return (
        <div>
            <Form form={form} onFinish={onFinish} className={style.form}>
                <div className={style.item}>
                    <div className={style.label}>
                        账号 <i className={style.required}>*</i>
                    </div>

                    <FieldWithError
                        name="username"
                        initialValue=""
                        rules={[
                            {
                                required: true,
                                message: "请输入账号"
                            }
                        ]}>
                        <Input placeholder="请输入账号" />
                    </FieldWithError>
                </div>

                <div className={style.item}>
                    <div className={style.label}>
                        密码 <i className={style.required}>*</i>
                    </div>

                    <FieldWithError
                        name="password"
                        initialValue={""}
                        rules={[
                            {
                                required: true,
                                message: "请输入密码"
                            }
                        ]}>
                        <Input.Password placeholder="请输入密码" />
                    </FieldWithError>
                </div>

                {captcha && (
                    <div className={style.item}>
                        <Row gutter={10} align="middle">
                            <Col span={16}>
                                <FieldWithError
                                    name="code"
                                    initialValue={""}
                                    rules={[
                                        {
                                            required: true,
                                            message: "请输入验证码"
                                        }
                                    ]}>
                                    <Input placeholder="请输入验证码" />
                                </FieldWithError>
                            </Col>
                            <Col span={8}>
                                <img
                                    className={style.captcha}
                                    onClick={() =>
                                        refreshCaptcha?.(
                                            form.getFieldValue("username")
                                        )
                                    }
                                    src={captcha}
                                    alt="code"
                                />
                            </Col>
                        </Row>
                    </div>
                )}

                <Button
                    htmlType="submit"
                    type="primary"
                    className={style.submit}
                    loading={loading}>
                    登录
                </Button>
            </Form>

            <div className={style.footer}>
                {isTrue(loginMode.unifyAuthLogin) && (
                    <Button
                        type="link"
                        className={style.btn}
                        href={loginUnifySet.ssoUrl}>
                        <Icon type="export" /> 统一身份认证入口
                    </Button>
                )}
            </div>
        </div>
    );
}
